import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "edit-phase-Modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_7 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  for: "Priority",
  class: "to-upper"
}
const _hoisted_14 = { value: "3" }
const _hoisted_15 = { value: "2" }
const _hoisted_16 = { value: "1" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { for: "Startdate" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { for: "Startdate" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "Enddate" }
const _hoisted_26 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (!_ctx.state.data.updates.edit_start_date && !_ctx.state.data.updates.edit_end_date)
              ? (_openBlock(), _createBlock("h5", _hoisted_6, _toDisplayString(_ctx.$t('add_date_to_task')), 1))
              : (_openBlock(), _createBlock("h5", _hoisted_7, _toDisplayString(_ctx.$t('edit_task_details')), 1)),
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideCheckAvaibilityModal && _ctx.hideCheckAvaibilityModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_8
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('priority')), 1),
                  _withDirectives(_createVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.updates.priority_id = $event))
                  }, [
                    _createVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('high')), 1),
                    _createVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('medium')), 1),
                    _createVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('low')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.state.data.updates.priority_id]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('estimated_budget')), 1),
                  _withDirectives(_createVNode("input", {
                    disabled: "",
                    type: "text",
                    class: "form-control",
                    inputmode: "decimal",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.updates.edit_budget = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.updates.edit_budget]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('start_date')), 1),
                  _createVNode(_component_v_date_picker, {
                    modelValue: _ctx.state.data.updates.edit_start_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.updates.edit_start_date = $event)),
                    "min-date": _ctx.minDate
                  }, {
                    default: _withCtx(({ inputValue, inputEvents }) => [
                      _createVNode("input", _mergeProps({
                        class: "form-control",
                        value: inputValue
                      }, _toHandlers(inputEvents)), null, 16, ["value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "min-date"])
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('end_date')), 1),
                  _createVNode(_component_v_date_picker, {
                    class: !_ctx.state.data.updates.edit_start_date ? 'disabled' : '',
                    modelValue: _ctx.state.data.updates.edit_end_date,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.updates.edit_end_date = $event)),
                    "min-date": _ctx.state.data.updates.edit_start_date
                  }, {
                    default: _withCtx(({ inputValue, inputEvents }) => [
                      _createVNode("input", _mergeProps({
                        class: "form-control",
                        value: inputValue
                      }, _toHandlers(inputEvents), {
                        disabled: !_ctx.state.data.updates.edit_start_date
                      }), null, 16, ["value", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["class", "modelValue", "min-date"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            (!_ctx.state.data.updates.edit_start_date && !_ctx.state.data.updates.edit_end_date)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn default-btn mr-2",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateSelectedTask && _ctx.updateSelectedTask(...args))),
                  disabled: _ctx.updateStatus
                }, _toDisplayString(_ctx.state.ui.isLoading.updateSelectedTask  ? "Loading..." :'Set'), 9, ["disabled"]))
              : (_openBlock(), _createBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn default-btn mr-2",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateSelectedTask && _ctx.updateSelectedTask(...args))),
                  disabled: _ctx.updateStatus
                }, _toDisplayString(_ctx.state.ui.isLoading.updateSelectedTask  ? _ctx.$t('loading1') :_ctx.$t('update')), 9, ["disabled"])),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideCheckAvaibilityModal && _ctx.hideCheckAvaibilityModal(...args)))
            }, _toDisplayString(_ctx.$t('cancel')), 1)
          ])
        ])
      ])
    ])
  ]))
}